import * as React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import './planner.scss';
import { DefaultButton, Dropdown, PrimaryButton, Stack } from 'office-ui-fabric-react';
import { Language } from '../../Utils/Language';
import MIPADatePicker from '../Common/datepicker';
import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import { Helper } from '../../Utils/Helper';
import TaskCommentService from '../../service/TaskCommentService';
import { GraphRequest } from '../../Utils/GraphRequest';
import { MIAPACons } from '../../Utils/MipaConstant';
import moment from 'moment';
import { TimezoneHelper } from '../../Utils/TimezoneHelper';
import Loading from '../Common/Loading';

// option list for time dropdown
const TimeDropdownOptions = [
  { key: '12:00 AM', text: '12:00 AM' },
  { key: '12:30 AM', text: '12:30 AM' },
  { key: '01:00 AM', text: '1:00 AM' },
  { key: '01:30 AM', text: '1:30 AM' },
  { key: '02:00 AM', text: '2:00 AM' },
  { key: '02:30 AM', text: '2:30 AM' },
  { key: '03:00 AM', text: '3:00 AM' },
  { key: '03:30 AM', text: '3:30 AM' },
  { key: '04:00 AM', text: '4:00 AM' },
  { key: '04:30 AM', text: '4:30 AM' },
  { key: '05:00 AM', text: '5:00 AM' },
  { key: '05:30 AM', text: '5:30 AM' },
  { key: '06:00 AM', text: '6:00 AM' },
  { key: '06:30 AM', text: '6:30 AM' },
  { key: '07:00 AM', text: '7:00 AM' },
  { key: '07:30 AM', text: '7:30 AM' },
  { key: '08:00 AM', text: '8:00 AM' },
  { key: '08:30 AM', text: '8:30 AM' },
  { key: '09:00 AM', text: '9:00 AM' },
  { key: '09:30 AM', text: '9:30 AM' },
  { key: '10:00 AM', text: '10:00 AM' },
  { key: '10:30 AM', text: '10:30 AM' },
  { key: '11:00 AM', text: '11:00 AM' },
  { key: '11:30 AM', text: '11:30 AM' },
  { key: '12:00 PM', text: '12:00 PM' },
  { key: '12:30 PM', text: '12:30 PM' },
  { key: '01:00 PM', text: '01:00 PM' },
  { key: '01:30 PM', text: '01:30 PM' },
  { key: '02:00 PM', text: '02:00 PM' },
  { key: '02:30 PM', text: '02:30 PM' },
  { key: '03:00 PM', text: '03:00 PM' },
  { key: '03:30 PM', text: '03:30 PM' },
  { key: '04:00 PM', text: '04:00 PM' },
  { key: '04:30 PM', text: '04:30 PM' },
  { key: '05:00 PM', text: '05:00 PM' },
  { key: '05:30 PM', text: '05:30 PM' },
  { key: '06:00 PM', text: '06:00 PM' },
  { key: '06:30 PM', text: '06:30 PM' },
  { key: '07:00 PM', text: '07:00 PM' },
  { key: '07:30 PM', text: '07:30 PM' },
  { key: '08:00 PM', text: '08:00 PM' },
  { key: '08:30 PM', text: '08:30 PM' },
  { key: '09:00 PM', text: '09:00 PM' },
  { key: '09:30 PM', text: '09:30 PM' },
  { key: '10:00 PM', text: '10:00 PM' },
  { key: '10:30 PM', text: '10:30 PM' },
  { key: '11:00 PM', text: '11:00 PM' },
  { key: '11:30 PM', text: '11:30 PM' }
];
// option list for duration dropdown
const DurationDropdownOptions = [
  { key: '30', text: '30 Minutes' },
  { key: '60', text: '1 Hour' },
  { key: '120', text: '2 Hour' },
  { key: '180', text: '3 Hour' },
  { key: '240', text: '4 Hour' },
  { key: '480', text: '8 Hour' },
];
// property interface
export interface IProps {
  data?: CPlannerTask;
  Language: any;
  DueDate: any;
  Time: any;
  Duration: any;
  dismisBTICPanel: any;
  CurrentUser: any;
  Progress: any;
  Header: any;
};

// Book Time In Your Calendar Panel Component
export default class BTICPanelContent extends React.Component<IProps> {

  public refloading: any;

  // validation message properties
  private DueDateValidationMessages = [];
  private TimeValidationMessages = [];
  private DurationValidationMessages = [];

  // form properties
  private DueDate: any;
  private Time: any;
  private Duration: any;
  private TenantId: any;

  // default constructor
  constructor(props: IProps | Readonly<IProps>) {
    super(props);
    this.DueDate = this.props.DueDate;
    this.Time = this.props.Time;
    this.Duration = this.props.Duration;
    this.OnSaveClick = this.OnSaveClick.bind(this);
    this.HandleTimeChanged = this.HandleTimeChanged.bind(this);
    this.HandleDurationChanged = this.HandleDurationChanged.bind(this);
    this.Initialize();
    this.refloading = React.createRef();
  }

  // handle duration dropdown changed event
  HandleDurationChanged(event: any, option: { key: any; text: any }, index: any): void {
    this.Duration = option.key;
  }

  // handle duration dropdown changed event
  HandleTimeChanged(event: any, option: { key: any; text: any }, index: any): void {
    this.Time = option.key;
  }

  // handle save click event
  OnSaveClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {

    // reset validation messages
    this.DueDateValidationMessages = [];
    this.TimeValidationMessages = [];
    this.DurationValidationMessages = [];
    // validate form controls
    if (!this.DueDate) this.DueDateValidationMessages.push(<li>{Language.GetLanguageValue(this.props.Language, 'DueDateIsRequired')}</li>);
    if (!this.Time) this.TimeValidationMessages.push(<li>{Language.GetLanguageValue(this.props.Language, 'SelectTime')}</li>);
    if (!this.Duration) this.DurationValidationMessages.push(<li>{Language.GetLanguageValue(this.props.Language, 'SelectDuration')}</li>);
    // display validation message if any
    if (this.DueDateValidationMessages.length > 0) return this.setState({ changed: true });

    this.refloading.ShowHideLoading(true);
    let self = this;

    const taskId = this.props.data.id;
    const subject = this.props.data.title;

    let timeStartStr = Helper.convertTo24Time(this.props.Time);
    let timeStartArr: any[] = timeStartStr.split(':');
    let tdate = new Date(this.DueDate);
    let date = new Date(tdate.getFullYear(), tdate.getMonth(), tdate.getDate(), timeStartArr[0], timeStartArr[1], timeStartArr[2]);
    date.setMinutes(date.getMinutes() + parseInt(this.Duration));

    const endTimeDate = new Date(date);

    const endHours = String(endTimeDate.getHours()).padStart(2, '0');
    const endMnts = String(endTimeDate.getMinutes()).padStart(2, '0');
    let endTime = endHours + ':' + endMnts;

    const timezonename = TimezoneHelper.getTimeZoneName();
    var bticPostParams = {
      "attendees": [],
      "Subject": subject,
      "Body": {
        "ContentType": "HTML",
        "Content": `<a href='https://tasks.office.com/${self.TenantId}/en-us/Home/Task/${taskId}' style='box-sizing: border-box; margin: 0 0px 20px 10%; font-family: Segoe UI WestEuropean,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif;  -webkit-font-smoothing: antialiased;  color: white;  font-size: 14px;  font-weight: 500; background-color: #2f752e; border: 1px solid #2f752e; cursor: pointer; display: inline-block;  height: 32px;  min-width: 80px;  padding: 4px 20px 6px;text-decoration: none;'>${Language.GetLanguageValue(self.props.Language, 'viewTask')}</a>`
      },
      "Start": {
        "DateTime": `${moment(date).format("YYYY-MM-DD")}T${timeStartStr}`,
        "TimeZone": timezonename
      },
      "End": {
        "DateTime": `${moment(date).format("YYYY-MM-DD")}T${endTime}:00`,
        "TimeZone": timezonename
      },
      "ShowAs": "Free",
      "reminderMinutesBeforeStart": 15,
      "IsReminderOn": true,
      originalStartTimeZone: timezonename,
      originalEndTimeZone: timezonename
    };

    let bticPostParamsSuccessCallback = function (data: any) {
      if (data != null) {
        const commentParams = {
          commenttext: `${Language.GetLanguageValue(self.props.Language, 'commentTextEventCreatedOnCalendarToBookTime')}.`,
          props: {
            CurrentUser: self.props.CurrentUser,
            ThreadId: self.props.data.conversationThreadId,
            data: self.props.data,
            Header: self.props.Header,
            Progress: self.props.Progress
          },
          detailSuccesscallback: function (successres: any) {
            self.refloading.ShowHideLoading(false);
            self.props.dismisBTICPanel();
          },
          detailErrorcallback: function (detailError: any) { },
          errorcallback: function (error: any) { },
          successcallback: function (sucres: any) {
          }
        };

        TaskCommentService.savecomment(commentParams);
        self.props.dismisBTICPanel();
      }
    };

    const bticPostParamsErrorCallback = function (error: any) {
      self.refloading.ShowHideLoading(false);
    };

    let header = self.props.Header;
    let api = `${MIAPACons.GraphAPI.GraphBaseURL}${MIAPACons.GraphAPI.MyEvents}`;
    GraphRequest.POST(api, header, bticPostParams, bticPostParamsSuccessCallback, bticPostParamsErrorCallback, this.props.Progress);
  }

  // initiate defauls
  Initialize(): void {
    let self = this;
    if (window.location.href.indexOf('localhost')) {
      self.TenantId = 'd11df2a9-bb65-4736-bdbc-3c7169a04250';
    } else {
      microsoftTeams.getContext((context: microsoftTeams.Context) => {
        self.TenantId = context.tid;
      });
    }
  }
  // render panel content
  public render() {
    return (
      <div className='m-lr-24-n'>
        <div className="btic-panel-title d-block">
          <span>{Language.GetLanguageValue(this.props.Language, 'booktimeinyourcalendar')}</span>
        </div>
        <div className="p-10 d-block ms-bgColor-white m-20">
          <Stack>
            <Stack.Item>
              <label className="ms-Label">{Language.GetLanguageValue(this.props.Language, 'dueDate')}</label>
              <MIPADatePicker
                datevalue={this.DueDate}
                showIcon={false}
                ChangeDate={(date: any) => { this.DueDate = date; }} />
              <ul className="error fiel-validation-ul">{this.DueDateValidationMessages}</ul>
            </Stack.Item>
            <Stack.Item className='mt-10-i'>
              <Dropdown
                label={Language.GetLanguageValue(this.props.Language, 'time')}
                options={TimeDropdownOptions}
                defaultSelectedKey={this.Time}
                onChange={this.HandleTimeChanged}
                required={true} />
              <ul className="error fiel-validation-ul">{this.TimeValidationMessages}</ul>
            </Stack.Item>
            <Stack.Item className='mt-10-i'>
              <Dropdown
                label={Language.GetLanguageValue(this.props.Language, 'duration')}
                options={DurationDropdownOptions}
                defaultSelectedKey={this.Duration}
                onChange={this.HandleDurationChanged}
                required={true} />
              <ul className="error fiel-validation-ul">{this.DurationValidationMessages}</ul>
            </Stack.Item>
          </Stack>
          <Stack horizontal className=' m-20 ml-0 d-flex-row jc-sb '>
            <DefaultButton
              className='w-48'
              text={Language.GetLanguageValue(this.props.Language, 'cancel')}
              onClick={this.props.dismisBTICPanel} />
            <PrimaryButton
              className='btn-success w-48'
              text={Language.GetLanguageValue(this.props.Language, 'book')}
              onClick={this.OnSaveClick} />
          </Stack>
        </div>
        <div className='panel-bg-worker-container'>
          <Loading ref={refel => (this.refloading = refel)} AddSpinner={true} />
        </div>
      </div>
    );
  }
}